import React from 'react';
import { educationData } from '../utils/constants';
import { GraduationCapIcon, AwardIcon, BookOpenIcon } from 'lucide-react';
const Education = ({
  language = 'en'
}) => {
  const translations = {
    en: {
      education: 'My',
      educationHighlight: 'Education',
      minor: 'Minor:',
      gpa: 'GPA:',
      honorsAwards: 'Honors & Awards',
      relevantCourses: 'Relevant Courses',
      certifications: 'Certifications',
      externalPrograms: 'External Programs'
    },
    vi: {
      education: 'Học',
      educationHighlight: 'Vấn',
      minor: 'Chuyên ngành phụ:',
      gpa: 'GPA:',
      honorsAwards: 'Danh Hiệu & Giải Thưởng',
      relevantCourses: 'Các Khóa Học Liên Quan',
      certifications: 'Chứng Chỉ',
      externalPrograms: 'Chương Trình Bên Ngoài'
    }
  };
  const t = translations[language];
  return <section id="education" className="w-full py-24 bg-background" data-id="element-462">
      <div className="container mx-auto px-4" data-id="element-463">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16" data-id="element-464">
          {t.education}{' '}
          <span className="gradient-text" data-id="element-465">{t.educationHighlight}</span>
        </h2>
        <div className="bg-secondary rounded-2xl p-8 card-glow" data-id="element-466">
          <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-467">
            <div className="w-full md:w-1/3" data-id="element-468">
              <div className="flex items-center gap-3 mb-4" data-id="element-469">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center p-1" data-id="element-470">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2ap1op7RttLLXY16S5PhAA/Northeastern_logo2.png" alt="Northeastern University" className="max-w-full max-h-full object-contain" data-id="element-471" />
                </div>
                <h3 className="text-2xl font-display font-bold" data-id="element-472">
                  {educationData.school}
                </h3>
              </div>
              <p className="text-accent-cyan mb-1" data-id="element-473">
                {language === 'en' ? educationData.degree : educationData.degreeVi}
              </p>
              <p className="text-muted mb-1" data-id="element-474">
                {t.minor}{' '}
                {language === 'en' ? educationData.minor : educationData.minorVi}
              </p>
              <p className="text-muted mb-1" data-id="element-475">
                {t.gpa} {educationData.gpa}
              </p>
              <p className="text-muted" data-id="element-476">
                {language === 'en' ? educationData.dates : educationData.datesVi}
              </p>
            </div>
            <div className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-477">
              <div data-id="element-478">
                <div className="flex items-center gap-2 mb-3" data-id="element-479">
                  <AwardIcon size={20} className="text-accent-violet" data-id="element-480" />
                  <h4 className="text-lg font-display font-bold" data-id="element-481">
                    {t.honorsAwards}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-482">
                  {(language === 'en' ? educationData.honors : educationData.honorsVi).map((honor, index) => <li key={index} className="flex items-start gap-2" data-id="element-483">
                      <span className="text-accent-cyan mt-1" data-id="element-484">•</span>
                      <span className="text-muted" data-id="element-485">{honor}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-486">
                <div className="flex items-center gap-2 mb-3" data-id="element-487">
                  <BookOpenIcon size={20} className="text-accent-amber" data-id="element-488" />
                  <h4 className="text-lg font-display font-bold" data-id="element-489">
                    {t.relevantCourses}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-490">
                  {(language === 'en' ? educationData.courses : educationData.coursesVi).map((course, index) => <li key={index} className="flex items-start gap-2" data-id="element-491">
                      <span className="text-accent-cyan mt-1" data-id="element-492">•</span>
                      <span className="text-muted" data-id="element-493">{course}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-494">
                <div className="flex items-center gap-2 mb-3" data-id="element-495">
                  <div size={20} className="text-accent-cyan" data-id="element-496" />
                  <h4 className="text-lg font-display font-bold" data-id="element-497">
                    {t.certifications}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-498">
                  {(language === 'en' ? educationData.certifications : educationData.certificationsVi).map((cert, index) => <li key={index} className="flex items-start gap-2" data-id="element-499">
                      <span className="text-accent-cyan mt-1" data-id="element-500">•</span>
                      <span className="text-muted" data-id="element-501">{cert}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-502">
                <div className="flex items-center gap-2 mb-3" data-id="element-503">
                  <BookOpenIcon size={20} className="text-accent-violet" data-id="element-504" />
                  <h4 className="text-lg font-display font-bold" data-id="element-505">
                    {t.externalPrograms}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-506">
                  {(language === 'en' ? educationData.programs : educationData.programsVi).map((program, index) => <li key={index} className="flex items-start gap-2" data-id="element-507">
                      <span className="text-accent-cyan mt-1" data-id="element-508">•</span>
                      <span className="text-muted" data-id="element-509">{program}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Education;